export default {
    showPreLoader: function () {
        return;

        $('<div id="bigPreloader"></div>').appendTo('body')
            .html(`
                <span style="vertical-align:middle; display: table-cell;">
                    <i class="fas fa-cog fa-spin fa-7x"></i>
                </span>`)
            .css({
                position: 'fixed',
                width: '100%',
                height: '100%',
                background: 'rgba(255,255,255,0.9)',
                top: 0,
                left: 0,
                'z-index': 100000,
                'text-align': 'center',
                'display': 'table'
            });
    },
    hidePreLoader: function () {
        $('#bigPreloader').remove();
    },
    disableButtons: function (noPreloader) {
        $('input[type=submit], input[type=button], button').prop('disabled', true);
        this.hidePreLoader();
        if (!noPreloader) {
            this.showPreLoader();
        }
    },
    enableButtons: function () {
        $('input[type=submit], input[type=button], button').prop('disabled', false);
        this.hidePreLoader();
    },
    showNotification: function (message, params) {
        const settings = {
            blockClass: 'alert',
            duration: 10000, //Время отображения сообщения
            animationDuration: 500, //Длительность анимации
            alertType: 'success', //Цвет сообщения
            types: {//Варианты цветов сообщений
                success: 'alert-success',
                info: 'alert-info',
                warning: 'alert-warning',
                error: 'alert-danger'
            },
            position: 'se', //Позиционирование элемента
            margin: 30//Отступ
        };
        const css = {
            nw: {top: settings.margin + 'px', left: settings.margin + 'px'},
            ne: {top: settings.margin + 'px', right: settings.margin + 'px'},
            sw: {bottom: settings.margin + 'px', left: settings.margin + 'px'},
            se: {bottom: settings.margin + 'px', right: settings.margin + 'px'}
        };
        params = params || {};
        $.extend(true, settings, params);
        var direction = ['sw', 'se'].indexOf(settings.position) !== -1 ? 'bottom' : 'top';

        var $note = $('<div class="notification ' + settings.blockClass + ' ' + settings.types[settings.alertType] + '"></div>')
            .click(function (event) {
                event.preventDefault();
                removeNote($(this));
            })
            .css($.extend(true, css[settings.position], {position: 'fixed', display: 'none', 'z-index': 1050}))
            .appendTo('body')
            .html(message)
            .animate({opacity: 'show'}, settings.animationDuration)
            .delay(settings.duration)
            .animate({opacity: 'hide'}, settings.animationDuration)
            .delay(settings.animationDuration)
            .queue(function () {
                $(this).remove();
            });

        $('.' + settings.blockClass).not($note).each(function (index, element) {
            var block = $(element);
            var height = $note.height() + parseInt($note.css('padding')) * 2 + 10;
            block.css(direction, parseInt(block.css(direction)) + height + 'px');
        });

        function removeNote($noteToRemove) {
            var $notes = $('.' + settings.blockClass);
            var height = $noteToRemove.height() + parseInt($noteToRemove.css('padding')) * 2 + 10;
            var noteToRemoveIndex = $notes.index($noteToRemove);

            $noteToRemove.hide();
            $notes.each(function (index, element) {
                var block = $(element);
                if (index < noteToRemoveIndex) {
                    block.css(direction, parseInt(block.css(direction)) - height + 'px');
                }
            });
            $noteToRemove.remove();
        }
    },
    hideNotifications: function () {
        $('.notification').remove();
    },
    getParameterByName: function (name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    jsonStringify: function (s, emit_unicode) {
        var json = JSON.stringify(s);
        var result;
        if (emit_unicode) {
            result = json;
        } else {
            result = json.replace(/(\\\\)/g, '/')
                .replace(/(\\n)/g, ' ')
                .replace(/(\s+\\")/g, ' «')
                .replace(/("\\")/g, '"«')
                .replace(/(\\")/g, '»');
        }
        return result;
    },
    parseUrl: function (url = window.location.href) {
        var a = document.createElement('a'),
            params = null,
            segments = [],
            tmp;
        a.href = url;
        tmp = a.search.replace('?', '');
        if (tmp.length) {
            params = {};
            tmp = decodeURI(tmp);
            tmp = tmp.split('&');
            tmp.forEach(function (p) {
                var t = p.split('=');
                params[t[0]] = t[1];
            });
        }
        tmp = a.pathname.split('/');
        for (var i = 0; i < tmp.length; i++) {
            if (tmp[i] !== '') {
                segments.push(tmp[i]);
            }
        }

        return {
            url: a.href,
            protocol: a.protocol.replace(':', ''),
            host: a.host,
            port: a.port,
            path: a.pathname,
            search: a.search,
            params: params,
            segments: segments
        };
    },
    insertURLQueryParam: function (key, value) {
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        const url = new URL(window.location);
        url.searchParams.set(key, value);
        window.history.pushState(null, '', url.toString());
    },
    deleteQueryParam(key) {
        key = encodeURIComponent(key);

        const url = new URL(window.location);
        url.searchParams.delete(key);
        window.history.pushState(null, '', url.toString());
    },
    deleteAllQueryParams() {
        const url = new URL(window.location);
        const keys = [];
        url.searchParams.forEach((value, key) => {
            keys.push(key);
        });
        for (const key of keys) {
            url.searchParams.delete(key);
        }
        window.history.pushState(null, '', url.toString());
    },
    onErrorAjax: function (e) {
        let response;
        if (e.responseText !== undefined) {
            response = JSON.parse(e.responseText);
            let message = response.message;
            if (response.errors) {
                for (let error in response.errors) {
                    for (let serverMessage of response.errors[error]) message += `<br>${error}: ${serverMessage}`;
                }
            }
            this.showNotification(message, {alertType: 'error'});
        } else {
            this.showNotification('Server error.', {alertType: 'error'});
        }
        this.enableButtons();
        this.hidePreLoader();
    },
    updateCount: function (selector, selectorEmpty) {
        const countNode = $(selector);
        const count = parseInt(countNode.text()) - 1;
        const parentNode = countNode.parent();
        countNode.text(count);
        if (count === 0) {
            parentNode.text(parentNode.text().replace(/\s+\(.*/, ''));
            selectorEmpty && $(selectorEmpty).show();
        }
    },
    validateEmail: function (email) {
        var pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return pattern.test(email);
    },
    validateUrl: function (url) {
        var pattern = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/;

        return pattern.test(url);
    },
    getDatePickerSettings: function () {
        return {
            format: "yyyy-mm-dd",
            weekStart: 1,
            todayHighlight: true,
            autoclose: true,
            language: "ru"
        };
    },
    convertTimeStringToSeconds: function (time) {
        const tmp = time.split(':');
        let seconds = 0;
        for (let i = 0; i < tmp.length; i += 1) {
            const multiplier = (60 * -(i + 1 - tmp.length));
            seconds += tmp[i] * (multiplier ? multiplier : 1);
        }
        return seconds;
    },
    convertSecondsToTimeString: function (seconds) {
        const date = new Date(seconds * 1000);
        return (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
            + ':'
            + (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    },
    /**!
     * Get the contrasting color for any hex color
     * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
     * Derived from work by Brian Suda, https://24ways.org/2010/calculating-color-contrast/
     * @param  {String} hex_color A hex color value
     * @return {String} The contrasting color (black or white)
     */
    getContrast(hex_color) {
        // If a leading # is provided, remove it
        if (hex_color.slice(0, 1) === '#') {
            hex_color = hex_color.slice(1);
        }

        // If a three-character hexcode, make six-character
        if (hex_color.length === 3) {
            hex_color = hex_color.split('').map(function (hex) {
                return hex + hex;
            }).join('');
        }

        // Convert to RGB value
        const r = parseInt(hex_color.substr(0, 2), 16);
        const g = parseInt(hex_color.substr(2, 2), 16);
        const b = parseInt(hex_color.substr(4, 2), 16);

        // Get YIQ ratio
        const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

        // Check contrast
        return (yiq >= 128) ? 'black' : 'white';
    },
    getPlatformColor(platform_id) {
        return platform_id === 'xbox' ? '#0e7810' : '#003e93'
    },
    createCommentBlock(id, comment) {
        const $template = $('#templates').find('.template-comment').clone();
        const $avatar = $('#mainUserAvatar');
        const date = new Date();
        const time = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes();
        $template.find('.comment-avatar').attr('src', $avatar.attr('src'));
        $template.find('.comment-comment').text(comment);
        $template.find('.comment-like').data('id', id + '/like');
        $template.find('.comment-author').html(`<a href="/profile">${$avatar.attr('alt')}</a>, ${time}`);

        $template.prependTo('#comments');
    },
    comment(selector, url) {
        TRNMNT_sendData({
            selector: selector,
            method: 'post',
            url: url,
            success: response => {
                const $commentInput = $('#comment');
                this.createCommentBlock(response.data.id, $commentInput.val());
                $commentInput.val('');

                const $commentCount = $('#commentCount');
                $commentCount.text(+$commentCount.text() + 1);
            },
        });
    },
    like(selector, url) {
        $(document).on('click', selector, event => {
            event.preventDefault();
            const id = $(event.target).closest('div').data('id');

            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                type: 'post',
                url: url + (id ? '/' + id : ''),
                contentType: "application/json; charset=utf-8",
                processData: false,
                success: response => {
                    const $button = $(event.target);
                    const $likeCount = $button.closest('div').find('.like-count');
                    if ($button.hasClass('like-liked')) {
                        $likeCount.text(+$likeCount.text() - 1);
                    } else {
                        $likeCount.text(+$likeCount.text() + 1);
                    }
                    $button.toggleClass('like-liked');
                },
                error: this.onErrorAjax,
                context: this
            });
        });
    },

    createGameBlock(game, onClickCreateGame) {
        const $template = this.getGameTemplate();

        this.setGameLink(game, $template);
        if (game.is_group) {
            fillTeam('.home-team', $template, game.home);
            fillTeam('.away-team', $template, game.away);
        } else {
            fillPlayer('.home-team', $template, game.home, true);
            fillPlayer('.away-team', $template, game.away, false);
        }
        this.setGameFinalStatus(game, $template);
        this.setGameDates(game, $template);
        this.setGamePlayOffStage(game, $template);
        this.setGameEditButton(game, $template);
        this.setGameTournamentTitle(game, $template);

        return $template;

        function fillTeam(selector, $template, data) {
            const $team = $template.find(selector);

            $team.find('.played-team__title').text(data.title);
            $team.find('.played-team__logo img')
                .attr('src', data.avatar)
                .attr('alt', data.title);

            const $players = $team.find('.played-team__players');
            for (let player of data.players) {
                $players.append(`<li class="played-team__player rounded-circle"><img src="${player.avatar}" alt="${player.tag}"></li>`);
            }
        }

        function fillPlayer(selector, $template, data, home) {
            const $player = $template.find(selector);
            $player.addClass('justify-content-start');
            $player.addClass('justify-content-sm-between');

            if (home) {
                $player.find('.played-team__title').text(data.club.title);
                $player.find('.played-team__logo img').attr('src', data.club.logo).attr('alt', data.club.title);
            } else {
                $player.find('.played-team__logo img').attr('src', data.club.logo).attr('alt', data.club.title);
                $player.find('.played-team__title').text(data.club.title);
            }

            const $players = $player.find('.played-team__players');
            $players.addClass('align-items-start');
            $players.addClass('align-items-sm-center');
            if (selector === '.home-team') {
                $players.addClass('justify-content-end');
                $players.append(`<li class="ms-2 display12 text-end"><span class="fw-bold">${data.tag}</span><br><small class="text-muted">${data.name}</small></li>`);
                $players.append(`<li class="played-team__player ms-1 rounded-circle"><img src="${data.avatar}" alt="${data.tag}"></li>`);
            } else {
                $players.append(`<li class="played-team__player rounded-circle"><img src="${data.avatar}" alt="${data.tag}"></li>`);
                $players.append(`<li class="ms-2 display12"><span class="fw-bold">${data.tag}</span><br><small class="text-muted">${data.name}</small></li>`);
            }
        }
    },

    getGameTemplate() {
        return $('#templates').find('.match-card').clone();
    },

    setGameLink(game, $template) {
        $template.attr('href', game.link);
    },

    setGameFinalStatus(game, $template) {
        if (game.is_overtime) {
            $template.find('.match-result__info').text('ОТ');
        } else if (game.is_shootout) {
            $template.find('.match-result__info').text('Б');
        } else if (game.is_technical_defeat) {
            $template.find('.match-result__info').text('ТП');
        }
    },

    setGameDates(game, $template) {
        const $dates = $template.find('.match-result__dates .match-result__date');
        if (game.home.score !== null && game.away.score !== null) {
            const date = game.played_at ? new Date(game.played_at.date) : null;
            $template.find('.match-result__score').text(`${game.home.score} : ${game.away.score}`);
            $dates.eq(0).text(date ? date.getShortDate() : '__.__.____');
            $dates.eq(1).find('span').text(date ? date.getTimeString() + ' МСК' : '--:--');
            $dates.eq(1).find('.match-result__status img').attr('src', '/images/game_accepted.svg');
        } else {
            const date = game.planned_on ? new Date(game.planned_on.date) : null;
            $template.find('.match-result__score').text(date ? date.getTimeString() : 'TBD');
            if (date) {
                $dates.eq(0).text(date.getWeekDay());
                $dates.eq(1).find('span').text(date.getShortDate());
            }
            $dates.eq(1).find('.match-result__status img').attr('src', '/images/game_planned_on.svg');

            $template.find('.played-team').addClass('align-items-center')
                .children('.played-team__content')
                .removeClass('d-flex flex-column h-100');
        }
    },

    setGamePlayOffStage(game, $template) {
        if (game.playoff_stage) {
            $template.find('.match-result__playoff-stage').text(`${game.playoff_stage}`);
        } else if (game.division) {
            $template.find('.match-result__playoff-stage').text(`${game.division}`);
        }
    },

    setGameEditButton(game, $template) {
        if (!game.can_edit) {
            return;
        }

        if (game.id) {
            $template.find('.match-result__captains')
                .removeClass('visually-hidden')
                .on('click', event => {
                    event.preventDefault();
                    window.location.href = game.link + '/update';
                });
        } else {
            $template.find('.game-planned-on')
                .removeClass('d-none');
        }
    },

    setGameTournamentTitle(game, $template) {
        $template.find('.match-result__comp').text(game.tournament.title);
    },

    createPlayerBlock(player, draftTeams) {
        const $template = $('#templates').find('.free-card').clone();
        $template.data('id', player.id);
        if (draftTeams) {
            $template.addClass('mb-2');
        }
        const $time = $template.find('.free-card__time');
        const createdAt = new Date(player.created_at);
        let color = '#B22222';
        if (Date.now() - createdAt.getTime() < 3600000) {
            color = '#006400';
        } else if (Date.now() - createdAt.getTime() < 7200000) {
            color = '#FFA500';
        }
        $time.find('i').css('background-color', color);
        $time.find('span').text(this.timeAgo(createdAt));
        const $avatar = $template.find('.free-card__avatar')
            .attr('href', player.link);
        $avatar.find('img').attr('src', player.avatar).attr('alt', player.tag.tag);
        $avatar.find('span').addClass('fi-' + player.country_id);
        $template.find('.free-card__num')
            .text(player.number)
        $template.find('.free-card__name')
            .attr('href', player.link)
            .text(player.tag.tag);
        const $name = $template.find('.free-card__console')
            .attr('href', player.link);
        $name.find('span').text(player.name);
        if (player.tag.platform_id) {
            $template.find('.free-card__info-icon')
                .html('<i class="fa-brands fa-' + player.tag.platform_id + '" style="color: ' + (player.tag.platform_id === 'xbox' ? '#0e7810' : '#003e93') + ' !important;"></i>');
        }
        const $team = $template.find('.team-player-cards__nickname');
        if (player.team) {
            $team.find('a').attr('href', player.team.link);
            if (player.team.platform_id) {
                $team.prepend('<i class="fa-brands fa-' + player.team.platform_id + '" style="color: ' + (player.team.platform_id === 'xbox' ? '#0e7810' : '#003e93') + ' !important;"></i>')
            }
            $team.find('span').text(player.team.title);
        } else {
            $team.html('Свободный агент');
        }
        if (player.can_move && draftTeams && draftTeams.length) {
            let teams = '';
            for (let team of draftTeams) {
                teams += '<li><a class="dropdown-item" href="#" data-id="' + team.id + '">' + team.title + '</a></li>';
            }
            $template.append(
                '<div class="draft-team-move dropdown position-absolute top-0 mt-2 me-2" style="right: 40px;">' +
                '  <button class="btn btn-primary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">' +
                '    Переместить' +
                '  </button>' +
                '  <ul class="dropdown-menu">' + teams + '</ul>' +
                '</div>'
            )
        }
        if (player.can_delete) {
            $template.append('<button class="free-card-delete btn btn-danger btn-sm position-absolute top-0 end-0 mt-2 me-2" type="button"><i class="fa fa-solid fa-trash-alt"></i></button>');
        }

        const $positions = $template.find('.free-card__positions-grid');
        for (let position of player.positions) {
            $positions.append('<img src="/images/positions/' + position.short_title + '.svg" alt="' + position.title + '">');
        }

        return $template;
    },

    playerVersusTableColumns() {
        return {
            //Порядковый
            index: {
                data: null,
                className: "align-middle rounded-start text-end stats-data-platform",
                orderable: false,
                render: (data, type, full, meta) => {
                    const row = meta.row
                        + 1
                        + meta.settings._iDisplayLength
                        * Math.ceil(meta.settings._iDisplayStart / meta.settings._iDisplayLength);

                    return `<small class="text-muted">${row}</small>`;
                },
            },
            //Аватар
            avatar: {
                data: null,
                className: "align-middle stats-data-avatar",
                orderable: false,
                render: data => {
                    const country = data.country_id ?
                        ` <span class="fi fi-${data.country_id} fis rounded-circle position-absolute bottom-0 start-0"></span>`
                        : '';
                    const club = data.logo ?
                        ` <img src="${data.logo}" class="position-absolute top-0 end-0" style="height: 30px"></span>`
                        : '';

                    return `
                        <div class="position-relative">
                            <a href="${data.link}"><img src="${data.avatar}"
                                class="rounded-circle border-gradient"
                                style="height: 66px; width: 66px;"
                                alt="${data.tag}"
                            /></a>
                            ${country}
                            ${club}
                        </div>`;
                },
            },
            //Имя
            name: {
                data: null,
                className: "align-middle title-row",
                orderable: false,
                render: data => {
                    return `
                        <div>
                            <a href="${data.link}" class="fw-bold text-decoration-none">${data.tag}</a>
                        </div>
                        <div class="small text-muted">${data.name}</div>
                        <div class="small">${data.club !== null ? data.club : ''}</div>`;
                },
            },
            //Платформа
            platform: {
                data: null,
                className: "align-middle stats-data-platform",
                orderable: false,
                render: data => {
                    return data.platform_id
                        ? `<i class="fa-brands fa-${data.platform_id}"
                               style="color: ${TRNMNT_helpers.getPlatformColor(data.platform_id)}"
                            ></i>`
                        : '';
                },
            },
            //Кубки
            cups: cell('stats.cups', 'stats-data'),
            //Количество игр
            games: cell('stats.games', 'stats-data'),
            //Победы
            wins: cell('stats.wins', 'stats-data'),
            //Поражения
            loses: cell('stats.loses', 'stats-data', false, true),
            //Поражения в овертайме
            lose_overtime: cell('stats.lose_overtime', 'stats-data', false, true),
            //% побед
            wins_percent: cell('stats.wins_percent', 'stats-data', true),
            //Голы
            goals_for: cell('stats.goals_for', 'stats-data'),
            //+/-
            goal_diff: cell('stats.goal_diff', 'stats-data',),
            //Броски
            shots: cell('stats.shots', 'stats-data'),
            //Силовые приёмы
            hits: cell('stats.hits', 'stats-data'),
            //Процент пасов
            pass_percent: cell('stats.pass_percent', 'stats-data', true),
            //% выигранных вбрасываний
            faceoff: cell('stats.faceoff', 'stats-data', true),
            //Большинство
            powerplay: cell('stats.powerplay', 'stats-data', true),
            //Голов в меньшинстве
            shorthanded_goals: cell('stats.shorthanded_goals', 'stats-data rounded-end'),
        };

        function cell(
            dataKey,
            className = '',
            isPercent = false,
            defaultOrderSequence = false,
        ) {
            return {
                orderSequence: defaultOrderSequence ? ['asc', 'desc'] : ['desc', 'asc'],
                data: dataKey,
                className: "align-middle text-center fw-bold " + className,
                visible: true,
                render: data => data + (isPercent ? '%' : ''),
            }
        }
    },

    playerTableColumns(getPositionFilter, isGoalie = false) {
        return {
            //Порядковый
            index: {
                data: null,
                className: "align-middle rounded-start text-end stats-data-platform",
                orderable: false,
                render: (data, type, full, meta) => {
                    const row = meta.row
                        + 1
                        + meta.settings._iDisplayLength
                        * Math.ceil(meta.settings._iDisplayStart / meta.settings._iDisplayLength);

                    return `<small class="text-muted">${row}</small>`;
                },
            },
            //Номер игрока
            number: {
                data: 'number',
                orderable: false,
                className: "align-middle text-end stats-data-platform",
            },
            //Аватар
            avatar: {
                data: null,
                className: "align-middle stats-data-avatar",
                orderable: false,
                render: data => {
                    const country = data.country_id ?
                        ` <span class="fi fi-${data.country_id} fis rounded-circle position-absolute bottom-0 start-0"></span>`
                        : '';

                    return `
                        <div class="position-relative">
                            <a href="${data.link}"><img src="${data.avatar}"
                                class="rounded-circle border-gradient"
                                style="height: 66px; width: 66px;"
                                alt="${data.name}"
                            /></a>
                            ${country}
                        </div>`;
                },
            },
            //Игрок
            player: {
                data: null,
                className: "text-nowrap title-row",
                orderable: false,
                render: data => {
                    const country = data.country_id ?
                        ` <span class="fi fi-${data.country_id} fis rounded-circle player-info__flag"></span>`
                        : '';
                    const tag = data.tag && data.tag.tag ? data.tag.tag : '';
                    const team = typeof data.team === 'string'
                        ? data.team
                        : `<a href="${data.team.link}" class="me-2 text-decoration-none">${data.team.title}</a>`

                    return `
                        <div class="player-info">
                            <div class="player-info__images">
                                <a href="${data.link}" class="text-decoration-none"><img src="${data.avatar}" alt="${tag}" class="player-info__img"></a>
                                ${country}
                            </div>
                            <div class="player-info__content">
                                <div class="player-info__level bold-text"><a href="${data.link}"  class="text-decoration-none">${tag}</a></div>
                                ${data.tag && data.tag.platform_id ? '<div class="player-info__name display12 medium-text gray-text">' + data.name + '</div>' : ''}
                                <div class="player-info__team display12 bold-text red-text">${team}</div>
                            </div>
                        </div>`;
                },
            },
            //Платформа
            platform: {
                data: null,
                className: "align-middle stats-data-platform",
                orderable: false,
                render: data => {
                    return data.tag && data.tag.platform_id
                        ? `<i class="fa-brands fa-${data.tag.platform_id}"
                               style="color: ${TRNMNT_helpers.getPlatformColor(data.tag.platform_id)}"
                            ></i>`
                        : '';
                },
            },
            //Имя
            name: {
                data: null,
                className: "align-middle title-row",
                orderable: false,
                render: data => {
                    const badge = typeof data.team !== 'string' && data.team.country_id
                        ? `<span class="fi fi-${data.team.country_id} fis rounded-circle"></span>`
                        : `<span class="badge bg-secondary rounded-pill" style="background: ${data.team.background} !important; color: ${data.team.color} !important; border: ${data.team.color} 1px solid">${data.team.short_title}</span>`;
                    const team = typeof data.team === 'string'
                        ? `<span style="color: #ADB5BDFF;">${data.team}</span>`
                        : `<a href="${data.team.link}" class="me-2 text-decoration-none">${data.team.title} ${badge}</a>`;

                    const name = data.tag && data.tag.tag ? data.tag.tag : data.name;

                    return `<div><a href="${data.link}" class="fw-bold text-decoration-none">${name}</a></div>`
                        + (data.tag && data.tag.platform_id ? `<div class="small text-muted">${data.name}</div>` : '')
                        + `<div class="small">${team}</div>`;
                },
            },
            //Позиция
            position: {
                data: null,
                className: "align-middle text-center player-stats-position",
                orderable: false,
                render: data => {
                    let positions = '';

                    const positionFilter = getPositionFilter();

                    if (positionFilter === 'free') {
                        for (let i = 0; i < data.player.positions.length; i += 1) {
                            let position = data.player.positions[i];
                            positions += `
                            <img src="/images/positions/${position.short_title}.svg"
                                alt="${position.title}"
                                style="height: 1.4rem;"
                                class="me-2"
                            >`;
                            if (i === 2) {
                                positions += '<br>';
                            }
                        }
                    } else {
                        for (let position of data.positions) {
                            positions += `
                            <img src="/images/positions/${position.short_title}.svg"
                                alt="${position.title}"
                                style="height: 1.4rem;"
                                class="me-2"
                            >`;
                        }
                    }

                    return positions;
                },
            },
            //Количество игр
            games: cell('stats.games', 'stats-data'),
            //Очков
            points: cell('stats.points', 'stats-data', false, !isGoalie),
            //Голов
            goals: cell('stats.goals', 'stats-data', false, !isGoalie),
            //Ассистов
            assists: cell('stats.assists', 'stats-data', false, !isGoalie),
            //+/-
            plus_minus: cell('stats.plus_minus', 'stats-data', false, !isGoalie),
            //Броски
            shots: cell('stats.shots', 'stats-data', false, !isGoalie),
            //% бросков
            shots_percent: cell('stats.shots_percent', 'stats-data', true, !isGoalie),
            //% выигранных вбрасываний
            faceoff_percent: cell('stats.faceoff_percent', 'stats-data', true, !isGoalie),
            //Процент пасов
            passes_percent: cell('stats.passes_percent', 'stats-data', true, !isGoalie),
            //Отборы шайбы
            takeaways: cell('stats.takeaways', 'stats-data', false, !isGoalie),
            //Перехваты шайбы
            interceptions: cell('stats.interceptions', 'stats-data', false, !isGoalie),
            //Потери шайбы
            giveaways: cell('stats.giveaways', 'stats-data', false, !isGoalie),
            //Блокированные броски
            blocked_shots: cell('stats.blocked_shots', 'stats-data', false, !isGoalie),
            //Голов в большинстве
            power_play_goals: cell('stats.power_play_goals', 'stats-data', false, !isGoalie),
            //Голов в меньшинстве
            shorthanded_goals: cell('stats.shorthanded_goals', 'stats-data', false, !isGoalie),
            //Штрафные минуты
            penalty_minutes: cell('stats.penalty_minutes', 'stats-data', false, !isGoalie),
            //Победных голов
            game_winning_goals: cell('stats.game_winning_goals', 'stats-data', false, !isGoalie),
            //Силовые приёмы
            hits: cell('stats.hits', 'stats-data', false, !isGoalie),

            //Побед
            wins: cell('stats.wins', 'stats-data', false, isGoalie),
            //Поражений
            loses: cell('stats.loses', 'stats-data', false, isGoalie),
            //% спасений
            saves_percent: cell('stats.saves_percent', 'stats-data', true, isGoalie),
            //Пропущено голов за игру в среднем
            goal_against_per_game: cell('stats.goal_against_per_game', 'stats-data', false, isGoalie, true),
            //Спасения
            saves: cell('stats.saves', 'stats-data', false, isGoalie),
            //Пропущено голов
            goals_against: cell('stats.goals_against', 'stats-data', false, isGoalie, true),
            //Матчи на ноль
            shootouts: cell('stats.shootouts', 'stats-data', false, isGoalie),

            //Турниров
            // tournaments: cell('stats.tournaments', 'stats-data'),
            //Кубков
            // cups: cell('stats.cups', 'stats-data'),
        };

        function cell(
            dataKey,
            className = '',
            isPercent = false,
            isVisible = true,
            defaultOrderSequence = false,
        ) {
            return {
                orderSequence: defaultOrderSequence ? ['asc', 'desc'] : ['desc', 'asc'],
                data: dataKey,
                className: "align-middle text-center fw-bold " + className,
                visible: isVisible,
                render: data => data + (isPercent ? '%' : ''),
            }
        }
    },
    timeAgo(date) {
        const secWords = ['секунда', 'секунды', 'секунд'];
        const minWords = ['минута', 'минуты', 'минут'];
        const hrsWords = ['час', 'часа', 'часов'];
        const dayWords = ['день', 'дня', 'дней'];

        const diff = new Date().getTime() - date.getTime();
        if (diff < 60 * 1000) {
            const seconds = Math.round(diff / 1000);
            if (!seconds) {
                return 'Только что';
            }
            return words(seconds, secWords) + ' назад';
        } else if (diff < 60 * 60 * 1000) {
            const minutes = Math.trunc(diff / 1000 / 60);

            return words(minutes, minWords) + ' назад';
        } else if (diff < 60 * 60 * 24 * 1000) {
            const hours = Math.trunc(diff / 1000 / 60 / 60);
            const minutes = Math.trunc(diff / 1000 / 60 - hours * 60);

            return words(hours, hrsWords) + ' ' + words(minutes, minWords) + ' назад';
        } else {
            const days = Math.trunc(diff / 1000 / 60 / 60 / 24);

            return words(days, dayWords) + ' назад';
        }

        function words(time, words) {
            time = '' + time;
            const lastDigit = time[time.length - 1];
            if (time > 10 && time < 15) {
                return time + ' ' + words[2];
            }

            switch (lastDigit) {
                case '1':
                    return time + ' ' + words[0];
                case '2':
                case '3':
                case '4':
                    return time + ' ' + words[1];
                default:
                    return time + ' ' + words[2];
            }
        }
    },
    divisionLetter(division) {
        const letters = [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z',
        ];

        return letters[division - 1] ?? '—';
    },
};
